<template>
  <div
    class="detail bg-secondary-light radius-md d-flex d-flex_middle p-12 h-100 d-sm-block p-sm-8"
  >
    <div class="detail__icon mr-12 mr-sm-0 mx-sm-auto">
      <img class="img-cover" :src="picture" :alt="title" />
    </div>

    <div class="grid-col_full pt-sm-4 text-sm-center">
      <div class="fs-14 fs-sm-12 fw-bold text-uppercase">
        {{ title }}
      </div>
      <div class="fs-14 fs-sm-12 mt-4">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Detail",
  props: {
    iconName: {
      type: String,
      default: "",
    },
    picture: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss">
@import "./detail.scss";
</style>
